import FormTypes from './FormTypes';
export default [FormTypes.FACEBOOK_LEAD_AD];